import * as tslib_1 from "tslib";
import { IgrCellInfo } from "./igr-cell-info";
import { TemplateCellModel as TemplateCellModel_internal } from "./TemplateCellModel";
/**
 * Represents backing information for a template cell.
*/
var IgrTemplateCellInfo = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(IgrTemplateCellInfo, _super);
    function IgrTemplateCellInfo() {
        return _super.call(this) || this;
    }
    IgrTemplateCellInfo.prototype.createImplementation = function () {
        return new TemplateCellModel_internal();
    };
    Object.defineProperty(IgrTemplateCellInfo.prototype, "i", {
        /**
                                     * @hidden
                                     */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrTemplateCellInfo.prototype, "value", {
        /**
         * Sets or gets the value to provide to the template.
        */
        get: function () {
            return this.i.kh;
        },
        set: function (v) {
            this.i.kh = v;
        },
        enumerable: true,
        configurable: true
    });
    return IgrTemplateCellInfo;
}(IgrCellInfo));
export { IgrTemplateCellInfo };
//# sourceMappingURL=igr-template-cell-info.js.map
